import { IContentDocActionTypes, } from '../action-types';
export const onSetScene360Background_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_SCENE_360_BACKGROUND,
    payload,
});
export const onSetScene360InitialCameraRotation_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_SCENE_360_INITIAL_CAMERA_ROTATION,
    payload,
});
export const onSetVideoRenditionProgressData_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_VIDEO_RENDITION_PROGRESS_DATA,
    payload,
});
export const onSetActionTrigger = (payload) => ({
    type: IContentDocActionTypes.SET_ACTION_TRIGGER_CN_DOC,
    payload,
});
export const onSetChromaKeyProperties = (payload) => ({
    type: IContentDocActionTypes.SET_CHROMA_KEY_PROPERTIES_CN_DOC,
    payload,
});
export const onSetInitialTemplateSlug = (payload) => ({
    type: IContentDocActionTypes.SET_INITIAL_TEMPLATE_SLUG,
    payload,
});
export const onSetTargetImageReferenceObject = (payload) => ({
    type: IContentDocActionTypes.SET_TARGET_IMAGE_REFERENCE_OBJECT_CN_DOC,
    payload,
});
export const onRemoveIdlePoseTime = (entityId) => ({
    type: IContentDocActionTypes.REMOVE_IDLE_POSE_TIME,
    payload: { entityId },
});
export const onRemoveIdleAnimation = (entityId) => ({
    type: IContentDocActionTypes.REMOVE_IDLE_ANIMATION,
    payload: { entityId },
});
// Analytics
export const onSetAnalyticsTracking_Cn_Doc = (analyticsTrackingDict) => ({
    type: IContentDocActionTypes.SET_ANALYTICS_TRACKING,
    payload: analyticsTrackingDict,
});
// Copy screen scene content
export const onCopyScreenSceneContent = (activeSceneId, targetSceneId) => ({
    type: IContentDocActionTypes.COPY_SCREEN_SCENE_CONTENT,
    payload: { activeSceneId, targetSceneId },
});
export const onClearScreenSceneContent = (sceneId) => ({
    type: IContentDocActionTypes.CLEAR_SCREEN_SCENE_CONTENT,
    payload: sceneId,
});
// UNDO & REDO
export const onUndo_Cn_Doc = () => ({
    type: IContentDocActionTypes.UNDO_CN_DOC,
});
export const onRedo_Cn_Doc = () => ({
    type: IContentDocActionTypes.REDO_CN_DOC,
});
// Reparenting
export const onReparentComponent_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.REPARENT_COMPONENT_CN_DOC,
    payload,
});
// Set emitter properties
export const onSetEmitterProperties = (payload) => ({
    type: IContentDocActionTypes.SET_EMITTER_PROPERTIES_CN_DOC,
    payload,
});
export const onSetEmitterGroupProperties = (payload) => ({
    type: IContentDocActionTypes.SET_EMITTER_GROUP_PROPERTIES_CN_DOC,
    payload,
});
export const onSetEmitterBaseProperties = (payload) => ({
    type: IContentDocActionTypes.SET_EMITTER_BASE_PROPERTIES_CN_DOC,
    payload,
});
export const onRemoveTrackingImageData_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.REMOVE_TRACKING_IMAGE_DATA_CN_DOC,
    payload,
});
// Set position, scale & rotation
export const onSetPositions_Cn_Doc = (positionDict) => ({
    type: IContentDocActionTypes.SET_ENTITY_POSITIONS_CN_DOC,
    payload: positionDict,
});
export const onSetRotations_Cn_Doc = (rotationDict) => ({
    type: IContentDocActionTypes.SET_ENTITY_ROTATIONS_CN_DOC,
    payload: rotationDict,
});
export const onSetScales_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_SCALE_FACTORS_CN_DOC,
    payload,
});
// export const onSetRgbaColors_Cn_Doc: IOnSetRgbaColors_Cn_Doc = (payload) => ({
// 	type: IContentDocActionTypes.SET_ENTITY_COLORS_CN_DOC,
// 	payload,
// });
export const onSetComponentTransition_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_COMPONENT_TRANSITION_CN_DOC,
    payload,
});
export const onAddComponentAction_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.ADD_COMPONENT_ACTION_CN_DOC,
    payload,
});
export const onRemoveComponentAction_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.REMOVE_COMPONENT_ACTION_CN_DOC,
    payload,
});
export const onSetComponentAction_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_COMPONENT_ACTION_CN_DOC,
    payload,
});
export const onSetMultipleComponentProps_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_MULTIPLE_COMPONENT_PROPS_CN_DOC,
    payload,
});
export const onSetWebEmbed_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_WEB_EMBED_CN_DOC,
    payload,
});
export const onSetImageTracking_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_IMAGE_TRACKING_CN_DOC,
    payload,
});
export const onSetActiveSceneChildren_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_ACTIVE_SCENE_CHILDREN,
    payload,
});
export const onSetRootChildren_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.SET_ROOT_CHILDREN,
    payload,
});
export const onAddFaceLandmarkToScene_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.ADD_FACE_LANDMARK_TO_SCENE_CN_DOC,
    payload,
});
export const onAddAnchorGroupToScene_Cn_Doc = (payload) => ({
    type: IContentDocActionTypes.ADD_ANCHOR_GROUP_TO_SCENE_CN_DOC,
    payload,
});
export const onSetProjectColors_Cn_Doc = (payload) => {
    return {
        type: IContentDocActionTypes.ADD_PROJECT_COLORS_CN_DOC,
        payload,
    };
};
export const onSetProjectShadowsEnabled_Cn_Doc = (payload) => {
    return {
        type: IContentDocActionTypes.SET_PROJECT_SHADOWS_ENABLED_CN_DOC,
        payload,
    };
};
export const onSetDeviceType_Cn_Doc = (payload) => {
    return {
        type: IContentDocActionTypes.SET_DEVICE_CN_DOC,
        payload,
    };
};
export const onSetLaunchScreenId_Cn_Doc = (id, title) => {
    return {
        type: IContentDocActionTypes.SET_LAUNCH_SCREEN_ID,
        payload: { id, title },
    };
};
export const onSetLaunchScreenField_Cn_Doc = (fieldId, field) => {
    return {
        type: IContentDocActionTypes.SET_LAUNCH_SCREEN_FIELD,
        payload: { fieldId, field },
    };
};
export const onAddMediaFile_Cn_Doc = (payload) => {
    return { type: IContentDocActionTypes.ADD_MEDIA_FILE, payload };
};
export const onSetGrabnGoOptions_Cn_Doc = (payload) => {
    return {
        type: IContentDocActionTypes.SET_GRAB_N_GO_OPTIONS,
        payload,
    };
};
export const onSetIsWebxrEnabledExperience_Cn_Doc = (payload) => {
    return {
        type: IContentDocActionTypes.SET_IS_WEBXR_ENABLED_EXPERIENCE,
        payload
    };
};
export const onSetScreenRelativeScaleType_Cn_Doc = (payload) => {
    return {
        type: IContentDocActionTypes.SET_SCREEN_RELATIVE_SCALE_TYPE,
        payload
    };
};
